<template>
	<div class="col-9 ms-auto end-0 me-5 px-3">
		<div class="col-12 d-flex justify-content-end">
			<div class="col-3 mb-2">
				<DateSelector :date="date" @change="dateChanged($event)"></DateSelector>
			</div>
		</div>

		<div class="col-12 row">
			<!-- Sales -->
			<div class="d-flex card-info max-h col-3 m-auto shadow-sm" style="width: 24.5%;">
				<span class="mx-3 nav-icon fs-3">
					<i class="bi bi-receipt"></i>
				</span>
				<div class="d-flex flex-column">
					<span class="fw-bold fs-4">RD$ {{formatNumber(totalSales)}}</span>
					<span class="mb-5 text-muted">Ventas totales</span>
				</div>
			</div>
			<!-- Profit -->
			<div class="d-flex card-info max-h col-3 m-auto shadow-sm" style="width: 24.5%;">
				<span class="mx-3 nav-icon fs-3">
					<i class="bi bi-receipt"></i>
				</span>
				<div class="d-flex flex-column">
					<span class="fw-bold fs-4">RD$ {{ formatNumber(profit) }}</span>
					<span class="mb-5 text-muted">Beneficios</span>
				</div>
			</div>
			<!-- Invoices -->
			<div class="d-flex card-info max-h col-3 m-auto shadow-sm" style="width: 24.5%;">
				<span class="mx-3 nav-icon fs-3">
					<i class="bi bi-receipt"></i>
				</span>
				<div class="d-flex flex-column">
					<span class="fw-bold fs-4">{{ totalInvoices }}</span>
					<span class="mb-5 text-muted">Facturas</span>
				</div>
			</div>
			<!-- Discounts -->
			<div class="d-flex card-info max-h col-3 m-auto shadow-sm" style="width: 24.5%;">
				<span class="mx-3 nav-icon fs-3">
					<i class="bi bi-receipt"></i>
				</span>
				<div class="d-flex flex-column">
					<span class="fw-bold fs-4">RD$ {{ formatNumber(discounts) }}</span>
					<span class="mb-5 text-muted">Descuentos</span>
				</div>
			</div>
		</div>

		<div class="col-12 row mt-3">
			<div class="row card-info col-6 mx-auto shadow-sm" style="width: 49.5%;">
				<div class="col-12">
					<span class="fw-bold">Resumen de transacciones</span>
					<div id="chart" ref="chartContainer"></div>
				</div>
			</div>

			<div class="row card-info col-6 mx-auto shadow-sm" style="width: 49.5%;">
				<div class="col-12">
					<span class="fw-bold">Ultimas transacciones</span>
				</div>
				<div class="d-flex flex-column justify-content-around">
					<div class="invoice_record d-flex justify-content-around align-items-center shadow-sm fw-bold"
						v-for="invoice,i in latestInvoices" :key="i">

						<div class="col-3 fs-1 text-center">
							<i class="bi bi-receipt-cutoff"></i>
						</div>

						<div class="col text-center">
							<div class="col-12">
								{{invoice.user.name }}
							</div>
							<div class="col-12">
								{{invoice.date}}
							</div>
						</div>

						<div class="col-3 text-center">
							RD$ {{invoice.total}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DateSelector from './DateSelector.vue';

	export default {
  	components: { DateSelector },

		data(){
			return {
				date: [
          '01-' + moment().format('MM-YYYY'), // initial Date
          moment().format('DD-MM-YYYY'), 			// Final Date
        ],
				totalSales		: 0.00,
        profit        : 0.00,
        totalInvoices : 0,
        discounts			: 0,
				chartData			: null,
				latestInvoices: null
			}
		},

		methods:{
			getDashboardData(date){
        axios.get('/home/dashboard-data',{
					params: {
						'date': date
						? [ // formating dates
								this.dateToDBFormat(date[0]),
								this.dateToDBFormat(date[1]),
							]
						: null
					}
				})
        .then((res) => {
					this.profit 			 	= res.data.profit;
					this.discounts 		 	= res.data.discounts;
					this.totalSales 	 	= res.data.totalSales;
					this.totalInvoices 	= res.data.totalInvoices;
					this.latestInvoices = res.data.latestInvoices;

					this.chartData 		  = res.data.chartData;
				}).finally(() => {
					this.loadRender();
				})
      },

			/** This runs when the Dateselector value change */
			dateChanged(newValue){
				this.getDashboardData(newValue)
			},

			loadRender(){
        const t = this;
				let profitAndValues = Object.values(this.chartData);
				console.log("profitAndValues:", profitAndValues)

				var options = {
					chart: {
						width	: "100%",
    				height: "auto",
    				type	: "bar",
					},
					stroke: {
						width: 1,
						colors: ["#fff"],
					},
          labels:{
            formatter: function (val){
              return val + "xd";
            }
          },
					dataLabels: {
            enabled: false,
          },
					colors: ["#50ea83", "#2c68d6"],
					series: [
						{
							name: 'Ventas',
							data: profitAndValues.map(function(profitAndValue){
								return profitAndValue['sales'];
							}),
						},
						{
							name: 'Beneficio',
							data: profitAndValues.map(function(profitAndValue){
								return profitAndValue['profit'];
							})
						},
					],
          yaxis: {
            labels: {
              formatter: function(val) {
                return t.formatNumber(val)
              }
            }
          },
					xaxis: {
						categories: Object.keys(this.chartData),
					},
				}

				if(this.chart){ // It's not the first time loading
					this.chart.destroy();
				}
				this.chart = new ApexCharts(this.$refs.chartContainer, options);
				this.chart.render();
			},
		},

		created(){
			this.getDashboardData(null);
		}
	}
</script>

<style lang="scss">
	.card-info{
		gap: 4px;
		padding: 2em 8px;
		border-radius: 8px;
		background:var(--first-color);
		&.max-h{
			max-height: 166px;
		}
	}

	.invoice_record{
		padding: 8px 4px;
		border: 1px solid #f8f6f6;
		border-radius: 6px;
		div{
			box-sizing: content-box;
		}
		i{
			color:var(--success-color)
		}
	}
</style>
